import React from 'react';

export type BadgeTier = 'NONE' | 'BRONZE' | 'SILVER' | 'GOLD' | 'VAULT';

interface BadgeTierChipProps {
  tier: BadgeTier;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const tierConfig: Record<BadgeTier, { label: string; dots: number; colorClass: string; bgClass: string; glow?: boolean }> = {
  NONE:   { label: 'Unrated',  dots: 0, colorClass: 'text-badge-none',   bgClass: 'bg-badge-none/10',   glow: false },
  BRONZE: { label: 'Bronze',   dots: 1, colorClass: 'text-badge-bronze', bgClass: 'bg-badge-bronze/10', glow: false },
  SILVER: { label: 'Silver',   dots: 2, colorClass: 'text-badge-silver', bgClass: 'bg-badge-silver/10', glow: false },
  GOLD:   { label: 'Gold',     dots: 3, colorClass: 'text-badge-gold',   bgClass: 'bg-badge-gold/10',   glow: false },
  VAULT:  { label: 'Vault',    dots: 4, colorClass: 'text-badge-vault',  bgClass: 'bg-badge-vault/15',  glow: true  },
};

const sizeClasses = {
  sm:  'text-[10px] px-2 py-0.5 gap-1',
  md:  'text-xs px-2.5 py-1 gap-1.5',
  lg:  'text-sm px-3 py-1.5 gap-2',
};

export default function BadgeTierChip({ tier, size = 'md', className = '' }: BadgeTierChipProps) {
  const config = tierConfig[tier];
  const sizeClass = sizeClasses[size];

  return (
    <span
      className={`
        inline-flex items-center font-mono rounded-full border
        ${sizeClass}
        ${config.colorClass}
        ${config.bgClass}
        ${config.glow ? 'vault-glow border-badge-vault/40' : 'border-current/20'}
        ${className}
      `}
      style={{ borderColor: 'currentColor', borderOpacity: 0.2 }}
    >
      {config.dots > 0 && (
        <span className="tracking-tight">
          {'◆'.repeat(config.dots)}
        </span>
      )}
      <span className="font-mono-data font-medium">{config.label}</span>
    </span>
  );
}